import { useEffect } from 'react';
import { setUser } from '@sentry/react';
import { decodeToken } from '../core/lib/jwt';

export const useSetSentryUserId = (accessToken?: string): void => {
  const loggedUserId = accessToken && decodeToken(accessToken).uid;

  useEffect(() => {
    const userId = typeof loggedUserId === 'number' ? loggedUserId.toString() : loggedUserId;
    setUser({ id: userId });
  }, [loggedUserId]);
};
